document.querySelector('body').addEventListener('click', event => {
    if (document.querySelector('.modal')) {
        if (event.target.closest('.open-modal-js')) {
            event.preventDefault();
            document.querySelector('.modal').classList.add('modal__open');
            document.querySelector('body').classList.add('body__modal__open');
        }
        if (event.target.closest('.modal__close')) {
            event.preventDefault();
            document.querySelector('.modal').classList.remove('modal__open');
            document.querySelector('body').classList.remove('body__modal__open');
        }
        if (!event.target.closest('.open-modal-js') 
                && !event.target.closest('.modal__block') 
                // && !event.target.closest('.button-delete')
            ) {
            document.querySelector('.modal').classList.remove('modal__open');
            document.querySelector('body').classList.remove('body__modal__open');
        }
    }
})
